"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactVirtuoso = require("react-virtuoso");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const InnerItem = /*#__PURE__*/_react.default.memo(_ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
});
const getListHeight = length => {
  return (length < 6 ? length * 2 : 6 * 2) + 'rem';
};
const MenuList = /*#__PURE__*/_react.default.memo(_ref2 => {
  let {
    options,
    children,
    getValue,
    ...rest
  } = _ref2;
  const virtuosoRef = (0, _react.useRef)(null);
  return Array.isArray(children) ? /*#__PURE__*/_react.default.createElement(_reactVirtuoso.Virtuoso, {
    ref: virtuosoRef,
    overscan: {
      main: 12,
      reverse: 12
    },
    style: {
      height: `${getListHeight(rest?.selectProps?.maxOptions || children.length)}`
    },
    totalCount: rest?.selectProps?.maxOptions || children.length,
    itemContent: index => /*#__PURE__*/_react.default.createElement(InnerItem, {
      children: children[index]
    })
  }) : /*#__PURE__*/_react.default.createElement("div", null, children);
});
var _default = exports.default = MenuList;